import { createContext } from "react";

export const GameContext = createContext({
  gameList: [],
  fetching: false,
  setFetching: () => {},
  addGame: () => {},
  deleteGame: () => {},
  addGamesFromServer: () => {},
  editGame: () => {}
});

